<template lang="html">
  <div class="popup" :class="{'visible': showPopup }">
    <div class="container">
      <div class="wrapper" :style="{'marginTop': offsetTop}">
        <div class="header">
          <div class="close" @click="close()"></div>

          <div class="header-title text-center" v-if="installUrl">
            Premium Version unlocked
          </div>

          <div class="header-title" v-if="!installUrl">
            <p>Total today:</p>
            <p>$0.00</p>
          </div>
        </div>
        <div class="form-wrapper" v-if="!installUrl">

          <div class="apple-button-wrapper" v-if="$parent.apple_pay_available">
            <button class="apple-button" :class="{'loading': loading}" @click="$parent.payWithApplePay()">Continue with&nbsp;<span class="apple">Pay</span></button>
            <div class="or">or</div>
          </div>

          <form id="card-pay-form">
            <input v-model="user.email" class="email" name="email" type="email" required placeholder="Email address">

            <div id="stripe-card-form"></div>

            <button type="submit" :class="{'loading': loading }">TRY FOR FREE</button>

            <p class="error" v-if="error">Subscription failed, please review form or try again later.</p>
          </form>

          <div>
            <div class="note">
            *By continuing you agree that if you don't cancel at least 24 hours prior to the end of the {{ $parent.trial_days }}-days trial, you will automatically be charged $&nbsp;{{ $parent.price }} / {{ $parent.interval }} auto-renewable due to subscription plan chosen above every mentioned plan's period until you cancel it.
            </div>
            <p class="note">If you have any questions please contacts us at {{ support_email }}</p>
          </div>

        </div>
        <div class="form-wrapper" v-if="installUrl">
          <p>Use link below to download  from App Store</p>
          <a class="install-link" :href="installUrl">
            <img src="/media/pulse-new/email/download-on-appstore.svg" alt="AppStore link">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      installUrl: null,
      user: {
        email: null,
      },
      visible: false,
      error: false,
      loading: false,
      offsetTop: null,
      support_email: 'support@' + location.hostname,
      cardFormSubmited: false,
    }
  },
  computed: {
    showPopup() {
      return !!(this.visible || this.installUrl)
    }
  },
  methods: {
    open(offsetTop) {
      document.body.style.overflowY = 'hidden'
      this.visible = true

      if (offsetTop && offsetTop > 0) {
        this.offsetTop = offsetTop + 'px'
      } else {
        this.offsetTop = null
      }
    },
    close() {
      document.body.style.overflowY = ''
      this.visible = false

      if (this.installUrl) {
        document.location.reload()
      }
    },
    initForm(stripe) {
      const elements = stripe.elements({ locale: 'en' })

      // 1. Create card form
      const elementStyles = {
        base: {
          iconColor: "#ccc",
          color: "#000",
          fontWeight: 400,
          fontFamily: "-apple-system, BlinkMacSystemFont, Helvetica, sans-serif",
          fontSize: "16px",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "#4E2D01"
          },
          ":-webkit-autofill": {
            color: "#4E2D01"
          }
        },
        invalid: {
          iconColor: "#f4423a",
          color: "#f4423a"
        }
      }

      const elementClasses = {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid',
      }

      let card = elements.create('card', {
        hidePostalCode: true,
        iconStyle: "solid",
        style: elementStyles,
        classes: elementClasses,
      })

      card.mount('#stripe-card-form')

      // Bind form submit handler 
      let form = document.querySelector('#card-pay-form')
      let self = this

      form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.loading = true

        if (this.cardFormSubmited) { return }

        this.$parent.user_email = this.user.email
        this.error = false
        this.cardFormSubmited = true

        let showError = () => {
          this.error = true
          this.cardFormSubmited = false
          this.loading = false
        }

        let completePayment = (reToken) => {
          this.loading = false

          stripe.createToken(card).then((result) => {
            if (result.error) {
              showError()
            } else {
              // Send the token to your server.
              this.$parent.createSubscription(result.token, null, reToken)
            }
          })
        }

        // Check recaptcha
        grecaptcha.ready(() => {
          grecaptcha.execute(
            this.$parent.session.session.recaptcha_key,
            {action: 'subscribe'}
          ).then((token) => {
            completePayment(token)
          }).catch((error) => {
            this.$parent.$parent.$refs.tracker.report('recaptcha_client_error')
            showError()
          })
        })

        return false
      })
    },
    success(url) {
      this.$parent.$parent.$refs.tracker.report('start_trial')

      let getCookie = (name) => {
        let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
          if (match) return match[2]
      }

      let parts = document.location.href.split('?')
      let pageParams = new URLSearchParams(parts.length > 1 ? parts[1] : '')

      for (let p of ['_fbp', '_fbc']) {
        if (!pageParams.has(p)) {
          pageParams.set(p, getCookie(p))
        }
      }

      parts = url.split('?')

      if (parts.length > 1) {
        let urlParams = new URLSearchParams(parts[1])

          for (let p of urlParams) {
            pageParams.set(p[0], p[1])
          }

        url = parts[0]
      }

      url = [url, pageParams.toString()].join('?')

      this.installUrl = url
    }
  }
}
</script>

<style lang="sass" scoped>
.card-holder
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center
  box-sizing: border-box
  margin-bottom: 10px

.first-name, .last-name, .email
  border: 1px solid #d7d7d9
  border-radius: 3px
  box-sizing: border-box
  color: #545457
  line-height: 30px
  padding: 0 5px
  width: calc(50% - 3px)
  outline: none
  
  &::placeholder
    color: #A9A9A9

  &:focus
    border-color: #8c8c91

.email
  width: 100%

.card-form-title
  display: block !important
  height: 25px
  line-height: 1.7
  font-size: 14px
  margin-bottom: 4px

.card
  padding: 0.625rem
  background: #f9f9f9
  margin-bottom: 1rem
  border-radius: 0.5rem

#stripe-card-form
  border: 1px solid #d7d7d9
  border-radius: 3px
  box-sizing: border-box
  padding: 5px 5px
  margin-top: 5px
</style>
